// extracted by mini-css-extract-plugin
export default {"root":"style_root__KBGOd","tabItem":"style_tabItem__mpiLQ","active":"style_active__aeKxu","firstItem":"style_firstItem__Fq2kJ"};